import { DirectionalAgreementData } from '../types';
import { AlignmentStatus } from '../types';

/**
 * Mock data for Directional Agreement component
 * This data represents community consensus and flow aggregation
 */
export const MOCK_DIRECTIONAL_AGREEMENT_DATA: DirectionalAgreementData = {
  agreementScore: 74,
  scoreDescription: 'Near boundary between zones',
  alignmentLabel: 'High directional alignment',
  sampleCount: 1876,
  breakdown: {
    positions: AlignmentStatus.ALIGNED,
    volume: AlignmentStatus.FRAGMENTED,
    recentFlow: AlignmentStatus.MIXED,
  },
};

/**
 * Translation keys for educational content
 */
export const EDUCATIONAL_CONTENT_KEYS = {
  title: 'directionalAgreement.educational.title',
  whatThisMeansTitle: 'directionalAgreement.educational.whatThisMeansTitle',
  whatThisMeans: 'directionalAgreement.educational.whatThisMeans',
  howItImpactsTitle: 'directionalAgreement.educational.howItImpactsTitle',
  howItImpacts: {
    highScores: 'directionalAgreement.educational.howItImpacts.highScores',
    lowScores: 'directionalAgreement.educational.howItImpacts.lowScores',
    suddenChanges:
      'directionalAgreement.educational.howItImpacts.suddenChanges',
  },
  tradingDecisionTitle: 'directionalAgreement.educational.tradingDecisionTitle',
  tradingDecision: 'directionalAgreement.educational.tradingDecision',
  bottomLineTitle: 'directionalAgreement.educational.bottomLineTitle',
  bottomLine: 'directionalAgreement.educational.bottomLine',
} as const;

/**
 * Gauge geometry constants
 */
export const GAUGE_CONSTANTS = {
  /** Radius of the gauge arc */
  RADIUS: 80,
  /** Stroke width of the gauge arc */
  STROKE_WIDTH: 18,
  /** Start angle in degrees (left side, 180° = pointing left) */
  START_ANGLE: 180,
  /** End angle in degrees (right side, 0° = pointing right) */
  END_ANGLE: 0,
  /** Center X coordinate */
  CENTER_X: 100,
  /** Center Y coordinate (bottom of arc) */
  CENTER_Y: 100,
  /** SVG viewBox dimensions */
  VIEWBOX_SIZE: 200,
  /** Needle width */
  NEEDLE_WIDTH: 2.8,
  /** Number of decorative dots along the arc */
  DOT_COUNT: 30,
  /** Radius of each decorative dot */
  DOT_RADIUS: 1,
} as const;

/**
 * Factor card configuration
 */
export const FACTOR_CARD_CONFIG = {
  positions: {
    icon: 'TrendingUp' as const,
    translationKey: 'directionalAgreement.positions',
  },
  volume: {
    icon: 'Equalizer' as const,
    translationKey: 'directionalAgreement.volume',
  },
  recentFlow: {
    icon: 'Lightning' as const,
    translationKey: 'directionalAgreement.recentFlow',
  },
} as const;
